export default {"src":"/_next/static/media/icon.5659f381.svg","height":71,"width":73,"blurWidth":0,"blurHeight":0};